import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VerificationService {

  constructor(private http: HttpClient) {
  }

  sendVerifyEntityEmail(data: any) {
    return this.http.post(`${environment.apiUrl}/VerifyEntity/SendVerifyEntityEmail`, data);
  }

  updateEntityVerification(data: any) {
    return this.http.post(`${environment.apiUrl}/VerifyEntity/UpdateEntityVerification`, data);
  }

  sendVerifyEntityOTP(data: any) {
    return this.http.post(`${environment.apiUrl}/VerifyEntity/SendVerifyEntityOTP`, data);
  }

  sendVerifyEntityOTPToEntityUser() {
    return this.http.post(`${environment.apiUrl}/UserProfile/GenerateOtp`, {});
  }

  updateEntityVerificationOTP(data: any) {
    return this.http.post(`${environment.apiUrl}/VerifyEntity/UpdateEntityVerificationOTP`, data);
  }

  verifyEntityUserMobile(otp: any) {
    return this.http.post(`${environment.apiUrl}/UserProfile/VerfieOTP`, otp);
  }

}
